import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {useStore, parseJwt} from "../utils/useStores";

const PublicRoute = ({component: Component, restricted, ...rest}) => {
  const store = useStore();

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route {...rest} render={props => (
      store.isLoggedIn && restricted && (parseJwt(store.token)?.exp * 1000 > Date.now()) ?
        <Redirect to="/app" />
        : <Component {...props} />
    )} />
  );
};

export default PublicRoute;
